// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.customergroups', {
        url: '/customergroups',
        views: {
            'baseList': {
            templateUrl: 'main/base/customergroups/customergroups.tpl.html',
            controller: 'CustomerGroupsController as vm'
        }},
        resolve: {
            customergroups: customergroupsResolver
        }
    });
}

// @ngInject
function customergroupsResolver(CustomerGroupsApiService) {
    return CustomerGroupsApiService.getCustomerGroups();
}

// @ngInject
function CustomerGroupsController($rootScope, $state, $scope, customergroups, CustomerGroupsApiService, loadSpinnerService) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.customergroups = customergroups;
    vm.selectedCustomerGroupId = 0;
    vm.searchTerm = "";
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.customerGroupId; }, function(newValue, oldValue) {
            vm.selectedCustomerGroupId = parseInt($state.params.customerGroupId,10);
        });
        $rootScope.$on('CustomerGroup.Inserted', function(event, response) {
        });
        $rootScope.$on('CustomerGroup.Updated', function(event, response) {
        });
        $rootScope.$on('CustomerGroup.Deleted', function(event, response) {
        });
        $rootScope.$on('CustomerGroup.Changed', function(event, response) {
            loadCustomerGroups();
        });
    }

    function loadCustomerGroups() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        CustomerGroupsApiService.getCustomerGroups(request).then(function(response) {
            vm.customergroups = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadCustomerGroups();
    }

}

angular
    .module('base.customergroups', ['customergroups.api','customergroups.customergroup'])
    .config(stateConfig)
    .controller('CustomerGroupsController', CustomerGroupsController);
